export const PRODUCT_FEEDBACK_CATEGORIES = {
  WRONG_SIZE: { value: '1', label: 'product is the wrong size' },
  WRONG_COLOR: { value: '2', label: 'product is the wrong color' },
  WRONG_STYLE: { value: '3', label: 'product is the wrong style' },
  WRONG_PRICE: { value: '4', label: 'product is the wrong price' }
};

export const PRODUCT_FEEDBACK_CATEGORY_VALUES = Object.entries(PRODUCT_FEEDBACK_CATEGORIES)
  .reduce((accum, [key, category]) => ({
    ...accum,
    [category.value]: key
  }), {});

export const RENDER_FEEDBACK_CATEGORIES = {
  MISSING_ITEMS: { value: '1', label: 'render is missing items requested' },
  TOO_CLUTTERED: { value: '2', label: 'render is too cluttered' },
  MISSING_DETAILS: { value: '3', label: 'render is missing details from real room' }
};

export const RENDER_FEEDBACK_CATEGORY_VALUES = Object.entries(PRODUCT_FEEDBACK_CATEGORIES)
  .reduce((accum, [key, category]) => ({
    ...accum,
    [category.value]: key
  }), {});

export const FEEDBACK_ITEM_TYPES = {
  PRODUCT: 'PRODUCT_FEEDBACK',
  RENDER: 'RENDER_FEEDBACK'
};

export const FEEDBACK_ITEM_STATUSES = {
  STARTED: 'FEEDBACK_ITEM_STARTED',
  EDITING: 'FEEDBACK_ITEM_EDITING',
  CONFIRMED: 'FEEDBACK_ITEM_CONFIRMED'
};
